module.exports = {"TXTCLI_Share_link":{"id":"TXTCLI_Share_link","defaultMessage":"Dela länk","track":"Share link"}}